import { PostPollFactory } from "./PostPollSectionTypes/PostPollFactory";
import { PostComponentsSection } from "../Post.styles";
import { PollType, PostIdType } from "../Post.types";
import { PollTypesEnum } from "@shared/Types/Polls";

export function PostPollPreview({
    postId,
    data,
    content,
}: {
    data: PollType;
    postId: PostIdType;
    content?: string;
}) {
    return (
        <PostComponentsSection>
            <PostPollFactory
                pollData={data}
                pollOptionHandler={() => Promise.resolve()}
                postId={postId}
                typeSpecificOpts={{
                    [PollTypesEnum.POLL_IMAGES]: { showSupportingText: false },
                }}
                content={content}
            />
        </PostComponentsSection>
    );
}
